/*
 * cacao-staffel.js — Mengenwahl fuer Crystal Cacao.
 * Job 20260802-cacao-us-shop-bundles-aufloesen-mengen-staffel-dynpreise-100g-prio30
 *
 * DIESE DATEI RECHNET NICHT. Jede Zahl steht fertig formatiert in den
 * data-Attributen der <option>, gerechnet von Liquid (snippets/cacao-staffel.liquid).
 * Das ist Absicht: sobald zwei Stellen denselben Preis ausrechnen, laufen sie
 * irgendwann auseinander — im selben Theme ist das schon passiert
 * (`data-variant-price` rechnete 19 % deutsche MwSt auf einen USD-Preis, waehrend
 * das Preis-Snippet daneben korrekt nach Land unterschied).
 *
 * Zweite Aufgabe: die gewaehlte Menge in den Warenkorb bringen. Der bestehende
 * Kakao-Handler in cart-drawer.js schrieb `quantity: 1` fest; er liest den Wert
 * jetzt ueber window.cacaoStaffelMenge().
 */
(function () {
  'use strict';

  /* ES GIBT ZWEI INSTANZEN, NICHT EINE. Die Kakaoseite rendert BEIDE Sections
     (product-template-cropped-kakao-1 und -2) — im Live-DOM stehen deshalb
     `productSelectKakao` UND `productSelectTwo` nebeneinander, die eine fuer
     Mobil, die andere fuer Desktop. Ein `querySelector` haette immer nur die
     erste erwischt: auf dem einen Viewport haette die Mengenwahl den Preis
     nicht bewegt, und in den Warenkorb waere die Menge der UNSICHTBAREN
     Auswahl gegangen. Alles hier arbeitet deshalb auf ALLEN Instanzen und
     haelt sie synchron. */
  function wurzeln() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cacao-staffel]'));
  }

  /* Die aktuell gewaehlte Menge. Fail-safe 1: lieber eine Dose zu wenig in den
     Warenkorb als eine erfundene Menge. Da alle Waehler synchron gehalten
     werden, ist der erste repraesentativ. */
  window.cacaoStaffelMenge = function () {
    var sel = document.querySelector('[data-cacao-menge]');
    if (!sel) return 1;
    var n = parseInt(sel.value, 10);
    return (isFinite(n) && n > 0) ? n : 1;
  };

  function setzeText(el, wert) {
    if (el && typeof wert === 'string' && wert.length) el.textContent = wert;
  }

  function aktualisiereEine(w, menge) {
    var sel = w.querySelector('[data-cacao-menge]');
    if (!sel) return;
    if (menge != null && sel.value !== String(menge)) sel.value = String(menge);
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;

    setzeText(w.querySelector('[data-cacao-je-packung]'), opt.getAttribute('data-je-packung'));
    setzeText(w.querySelector('[data-cacao-summe]'), opt.getAttribute('data-summe'));

    /* DIE ZWEI ZUSTAENDE DER BOX (Umbau 2026-08-08, Christian: "weniger Zahlen").
       Bei Menge 1 wiederholt die Box die Preis-Headline NICHT — der Anker waere
       dort der eigene Preis und die Ersparnis 0. Ab Menge 2 klappt die
       Ankerzeile auf: Regulaerpreis durchgestrichen, Summe gross, Ersparnis als
       Plakette, und der je-Packung-Preis erscheint als leise Rechtfertigung.

       DIE SICHTBARKEIT HAENGT AM VORHANDENSEIN DER ERSPARNIS, NICHT AN DER
       MENGE. Waere sie an `menge > 1` geknuepft, zeigte die Box bei
       abgeschalteter Staffel (staffel_aktiv = false, der fail-closed-Default)
       fuer 2 Packungen einen Anker von $178 gegen eine Summe von $178 und eine
       Ersparnis von nichts. `data-sparen` ist genau dann leer, wenn Liquid
       keinen Abzug gerechnet hat — dieselbe Wahrheit an einer Stelle statt an
       zweien. Der frueher hier gepflegte Grundpreis je Unze ist ersatzlos
       entfallen (Christian 2026-08-08: "pro oz streichen"). */
    var regulaer = opt.getAttribute('data-regulaer') || '';
    var sparen = opt.getAttribute('data-sparen') || '';
    var sparenDa = sparen.length > 0 && regulaer.length > 0;

    var anker = w.querySelector('[data-cacao-anker]');
    if (anker) anker.hidden = !sparenDa;

    var elRegulaer = w.querySelector('[data-cacao-regulaer]');
    if (elRegulaer) {
      /* Das Screenreader-Wort "Regular price" muss den Textwechsel ueberleben —
         deshalb wird der Knoten nicht ersetzt, sondern nach dem Setzen des
         Betrags wieder vorangestellt. */
      var sr = elRegulaer.querySelector('.cacao-staffel__sr');
      elRegulaer.textContent = regulaer;
      if (sr) elRegulaer.insertBefore(sr, elRegulaer.firstChild);
    }

    var elSparen = w.querySelector('[data-cacao-sparen]');
    if (elSparen) {
      elSparen.hidden = !sparenDa;
      if (sparenDa) elSparen.textContent = 'Save ' + sparen;
    }

    /* DIE KOPFZEILE FOLGT DER AUSWAHL — das ist der Punkt, den Christian am
       2026-08-24 ausdruecklich genannt hat ("dass sich die Kosten pro Packung
       live aendern"). Vorher stand dort unveraendert die Preis-Headline des
       Themes ($89), also eine Zahl, die zu keiner der Stufen passte, sobald man
       eine andere waehlte.

       AUCH HIER WIRD NICHT GERECHNET. Der Packungspreis steht als
       data-je-packung fertig am <option>; der Streichpreis ist der
       server-gerenderte Einzelpreis und aendert seinen WERT nie, nur seine
       Sichtbarkeit. Damit bleibt die Trennung "Liquid rechnet, JavaScript
       waehlt aus" auch fuer die Kopfzeile unangetastet.

       Der frueher hier gepflegte je-Packung-Preis der Detailzeile ist entfallen
       — er steht jetzt in der Kopfzeile und stuende sonst zweimal in derselben
       Box. */
    setzeText(w.querySelector('[data-cacao-kopf-preis]'), opt.getAttribute('data-je-packung'));

    var kopfStreich = w.querySelector('[data-cacao-kopf-streich]');
    if (kopfStreich) kopfStreich.hidden = !sparenDa;

    /* Die Auszeichnung wechselt Text UND Farbe. Der Stil kommt als Wort vom
       <option> (gold | rot | verlauf) und wird auf die Modifier-Klasse
       abgebildet — kein Farbwert im JavaScript, damit die Farben allein im
       Token-CSS stehen. Faellt das Attribut aus, bleibt die zuletzt gueltige
       Klasse stehen statt eine kaputte zu setzen. */
    var flagge = w.querySelector('[data-cacao-kopf-flagge]');
    if (flagge) {
      var text = opt.getAttribute('data-flagge') || '';
      var stil = opt.getAttribute('data-flagge-stil') || '';
      flagge.hidden = text.length === 0;
      if (text.length) flagge.textContent = text;
      if (stil.length) {
        flagge.className = 'cacao-kopf__flagge cacao-kopf__flagge--' + stil;
      }
    }

    /* Der Anreiz auf die zweite Stufe gilt nur, solange der Kunde auf der
       ersten steht. Hat er sie genommen, ist er kein Ziel mehr. */
    var n = parseInt(sel.value, 10) || 1;
    var nudge = w.querySelector('[data-cacao-nudge]');
    if (nudge) nudge.hidden = (n > 1);
  }

  /* Eine Auswahl gilt fuer die ganze Seite: erst alle Waehler angleichen, dann
     alle Anzeigen neu setzen. Sonst zeigt die zweite Instanz noch den alten
     Preis, waehrend der Warenkorb schon die neue Menge bekommt. */
  function aktualisiere(menge) {
    wurzeln().forEach(function (w) { aktualisiereEine(w, menge); });
  }

  function binde() {
    wurzeln().forEach(function (w) {
      var sel = w.querySelector('[data-cacao-menge]');
      if (!sel || sel.dataset.cacaoGebunden === '1') return;
      sel.dataset.cacaoGebunden = '1';
      sel.addEventListener('change', function () {
        aktualisiere(parseInt(sel.value, 10) || 1);
      });
    });
    aktualisiere(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', binde);
  } else {
    binde();
  }
})();
